<script>
import { required } from "vuelidate/lib/validators";

export default {
    name: "SlTypeModal",
    props: {
        modalTitle: {
            type: String,
            default: ""
        },
        submitted: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            form: {
                id: 0,
                code: "",
                type: "",
                categoryId: null,
            },
        };
    },
    validations: {
        form: {
            code: { required },
            type: { required },
        },
    },
    methods: {
        updateData(data){
            this.form = JSON.parse(JSON.stringify(data));
        },
        onReset() {
            this.form = {
                id: 0,
                code: "",
                type: "",
                categoryId: null,
            };
        },
        onCreate() {
            this.$emit('create', this.form);
        },
        hideModal() {
            this.$bvModal.hide("sl-type-modal");
        }
    }
};
</script>
<template>
    <b-modal
        id="sl-type-modal"
        :title="modalTitle"
        size="md"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <form
            @submit.prevent="onCreate"
            class="needs-validation"
            ref="slTypeForm"
        >
            <div class="mb-3">
                <label for="code">SL Type Code</label>
                <input
                    autocomplete="off"
                    id="code"
                    type="text"
                    v-model="form.code"
                    placeholder="Enter SL Type Code..."
                    class="form-control"
                    :class="{
                        'is-invalid': submitted && $v.form.code.$error,
                    }"
                />
                <div
                    v-if="submitted && $v.form.code.$error"
                    class="invalid-feedback"
                >
                    <span v-if="!$v.form.code.required">
                        This value is required.
                    </span>
                </div>
            </div>
            
            <div class="mb-3">
                <label for="type">SL Types</label>
                <input
                    autocomplete="off"
                    id="type"
                    type="text"
                    v-model="form.type"
                    placeholder="Enter SL Types..."
                    class="form-control"
                    :class="{
                        'is-invalid': submitted && $v.form.type.$error,
                    }"
                />
                <div
                    v-if="submitted && $v.form.type.$error"
                    class="invalid-feedback"
                >
                    <span v-if="!$v.form.type.required">
                        This value is required.
                    </span>
                </div>
            </div>
            
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary">
                    Save changes
                </button>
                <button
                    type="button"
                    class="btn btn-link"
                    @click="hideModal"
                >
                    Close
                </button>
            </div>
        </form>
    </b-modal>
</template>